//em processo de teste para criar um screenshot apos clicar em confirmar consentimento drawer OPTIN
import html2canvas from "html2canvas";
import { ITakeScreenshot } from "./types";
import "reflect-metadata";
import { injectable } from "inversify";

@injectable()
export default class useTakeScreenshot implements ITakeScreenshot {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected screenshotURL: any;
  private blob: Blob | null = null;

  constructor() {
    this.screenshotURL = null;
    this.blob = null;
  }

  async takeScreenshot(): Promise<Blob> {
    const screenshot = await html2canvas(document.body);
    const blob = await new Promise<Blob>((resolve, reject) => {
      screenshot.toBlob((b) => {
        if (b) {
          resolve(b);
        } else {
          reject(new Error("Erro ao converter a imagem para Blob"));
        }
      });
    });
    this.blob = blob;

    return blob;
  }

  async generateOnUrl() {
    const blob = await this.takeScreenshot();

    const screenshotURL = window.URL.createObjectURL(blob);
    window.open(screenshotURL, "noopener");
    setTimeout(() => {
      window.URL.revokeObjectURL(screenshotURL);
    }, 1000);
  }

  getBlob(): Blob | null {
    return this.blob;
  }
}
